<template>
    <a
        ref="triggerRef"
        class="nav-link nav-profile d-flex align-items-center pe-0"
        href="#"
        data-bs-toggle="dropdown"
        aria-expanded="false"
    >
      <img src="/assets/img/profile-img.jpg" alt="Profile" class="rounded-circle">
      <span class="d-none d-md-block dropdown-toggle ps-2">
        {{ currentUser?.email }}
      </span>
    </a>

    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
      <li class="dropdown-header">
        <h6>
          {{ currentUser?.firstName ? currentUser.firstName + ' ' + getInitial(currentUser?.lastName) : currentUser?.email }}
        </h6>
        <span>Пользователь</span>
      </li>

      <li><hr class="dropdown-divider"></li>

      <li>
        <a class="dropdown-item d-flex align-items-center" href="/personal">
          <i class="bi bi-person"></i>
          <span>Мой профиль</span>
        </a>
      </li>
      <li>
        <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="onLogout">
          <i class="bi bi-box-arrow-right"></i>
          <span>Sign Out</span>
        </a>
      </li>
    </ul>
</template>
<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { Dropdown } from 'bootstrap';
import { useRouter } from "vue-router";
import { usePersonal } from "@/features/personal/composables/usePersonal";

const router = useRouter();
const { currentUser, logout } = usePersonal();

const triggerRef = ref(null);
let dropdownInstance = null;

onMounted(() => {
  dropdownInstance = new Dropdown(triggerRef.value);
});

onUnmounted(() => {
  dropdownInstance?.dispose();
});

function onLogout() {
  logout();
  router.push('/auth');
}

function getInitial(name) {
  if (!name) return '';
  return name[0].toUpperCase() + '.';
}
</script>